import FizConfig from "../FizConfig.js";
import {addParams} from "../lib/url.ts";

  var
   // Constants

    // a special value to reset a date to empty
    EMPTY_DATE = "$empty";



  /*
    Function: encodeISODate(date): string
    Convert a date to the ISO string format expected by the API.

    Parameter:
      date - Date, a date to convert

    Returns:
      string, the converted date, in ISO format, with seconds fixed to '00'
              and the selected timeZone, or
      "$empty" if the date is null or undefined
  */
  function encodeISODate(date){
    if ( !date || isNaN(date) ){
      return EMPTY_DATE;
    }
    return date.toISOString();
  }
  
  function decodeISODate(iso8601){
    if(iso8601===null || iso8601===undefined || iso8601==='' || iso8601==='$empty'){
      return null;  
    }
    if(Date.prototype.toISOString){
      return new Date(iso8601);
    }else{
      return new Date(
          parseInt(iso8601.substring(0,4),10),
          parseInt(iso8601.substring(5,7),10) - 1,
          parseInt(iso8601.substring(8,10),10),
          parseInt(iso8601.substring(11,13),10),
          parseInt(iso8601.substring(14,16),10) - new Date().getTimezoneOffset(),
          parseInt(iso8601.substring(17,19),10),
          parseInt(iso8601.substring(20,23),10)
       );
    }
  }

  /*
    Function: getPictureUrl(pictureUri,width,height): string
    Add expected width/height parameters to a picture URI

    Parameters:
      pictureUri - string, picture URI received from server
      width - number, optional, the expected width for picture display,
        in pixels, defaults to DEFAULT_PICTURE_WIDTH
      height - number, optional, the expected height for picture display,
        in pixels, defaults to DEFAULT_PICTURE_HEIGHT

    Returns:
      string, a picture URL for the location of the given picture resized to
      the expected dimensions
  */
  function getPictureUrl(picture,width,height){
    if(!picture){
      return null;
    }
    return addParams(picture, {w:width,h:height,s:"c"});
  }

  function getDefaultUrl(name, color){
    name = name.trim();
    if(name.length>1){
      name = name.substring(0,1).toUpperCase()+name.substring(1,2);
    }else if(name.length===1){
      name = name.toUpperCase();
    }else{
      name = '?';
    }
    
    return addParams(FizConfig.API_BASE_URL+"avatardefault", {co:color,fn:name});
  }

  function hex2(a){
    if(a<16){
      return '0'+a.toString(16);
    }
    return a.toString(16);
  }
    
  class Color{
    constructor(s){
      if(typeof s ==='string'){
        if(s.indexOf('#')===0){
          if(s.length===9){
            this.r = parseInt(s.substring(1,3),16);
            this.g = parseInt(s.substring(3,5),16);
            this.b = parseInt(s.substring(5,7),16);
            this.a = parseInt(s.substring(7,9),16)/255;
          }else if(s.length===7){
            this.r = parseInt(s.substring(1,3),16);
            this.g = parseInt(s.substring(3,5),16);
            this.b = parseInt(s.substring(5,7),16);
            this.a = 1;
          }else if(s.length===4){
            this.r = parseInt(s.substring(1,2),16)*16;
            this.g = parseInt(s.substring(2,3),16)*16;
            this.b = parseInt(s.substring(4,5),16)*16;
            this.a = 1;
          }
          
        }else if(s.indexOf('rgb')===0){
          s = s.replace(/\s/g,'');
          var split = s.substring(4,s.length-1).split(',');
          this.r = parseInt(split[0]);
          this.g = parseInt(split[1]);
          this.b = parseInt(split[2]);
          if(split.length===4){
            this.a = parseFloat(split[3])
          }else{
            this.a = 1;
          }
        }  
      }else{
        this.r = s;
        this.g = arguments[1];
        this.b = arguments[2];
        this.a = arguments[3]||1;
      }
    }
    setOpacity(a){
      return new Color(this.r,this.g,this.b,a);
    }
    toString(){
      if(this.a===1){
        return '#'+hex2(this.r)+hex2(this.g)+hex2(this.b);
      }else{
        return 'rgba('+this.r+','+this.g+','+this.b+','+this.a+')';
      }
    }
  }  
export {encodeISODate,decodeISODate,getPictureUrl,getDefaultUrl,Color}


